export default __webpack_public_path__ + "static/media/image.01cce670.svg";